import { DocumentAttribute } from './document.model';

export const CONTEXT_DOC_TYPES = [
  {
    docType: 'credit_policy',
    attribute: DocumentAttribute.CONTEXT_CREDIT_POLICY,
    labelKey: 'GNR_CREDIT_POLICY',
  },
  {
    docType: 'term_sheet',
    attribute: DocumentAttribute.CONTEXT_EXAMPLE_TERM_SHEET,
    labelKey: 'GNR_TERM_SHEET',
  },
  {
    docType: 'credit_agreement',
    attribute: DocumentAttribute.CONTEXT_EXAMPLE_CREDIT_AGREEMENT,
    labelKey: 'GNR_CREDIT_AGREEMENT',
  },
  {
    docType: 'market_report',
    attribute: DocumentAttribute.CONTEXT_MARKET_REPORT,
    labelKey: 'GNR_MARKET_REPORT',
  },
  {
    docType: 'survey_results',
    attribute: DocumentAttribute.CONTEXT_SURVEY_RESULTS,
    labelKey: 'GNR_SURVEY_RESULTS',
  },
  {
    docType: 'other',
    attribute: DocumentAttribute.CONTEXT_OTHER,
    labelKey: 'GNR_DOC_TYPE_OTHER',
  },
] as const;

export type ContextDocType = (typeof CONTEXT_DOC_TYPES)[number]['docType'];

/** Narrowed to just the 6 `DocumentAttribute.CONTEXT_*` members. */
export type ContextDocAttribute =
  (typeof CONTEXT_DOC_TYPES)[number]['attribute'];

export const CONTEXT_DOC_TYPE_TO_ATTR = Object.fromEntries(
  CONTEXT_DOC_TYPES.map(({ docType, attribute }) => [docType, attribute])
) as Record<ContextDocType, ContextDocAttribute>;

export const CONTEXT_DOC_ATTR_TO_TYPE = Object.fromEntries(
  CONTEXT_DOC_TYPES.map(({ docType, attribute }) => [attribute, docType])
) as Record<ContextDocAttribute, ContextDocType>;
